import { client } from '@/main';
import gql from 'graphql-tag';

export const getSuggestedNumbers = async (areaCode: number, contains: string) => {
  try {
    let Q_NUMBERS;
    if (areaCode > 0) {
      Q_NUMBERS = gql`
        query Q_NUMBERS {
          available_phone_numbers(area_code: ${areaCode}) {
            phone_numbers {
              phone_number
            }
          }
        }
      `;
    } else {
      Q_NUMBERS = gql`
        query Q_NUMBERS {
          available_phone_numbers(contains: "${contains}") {
            phone_numbers {
              phone_number
            }
          }
        }
      `;
    }
    const result = await client.query({
      query: Q_NUMBERS
    });
    return result;
  } catch (error) {
    console.log('-- get phone numbers @ ERROR:', error);
    return error;
  }
};
